import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";


export const billing_expense_printInvDocRef = (inv_hid) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/print_inv_docref/${inv_hid}`);
};

export const billing_expense_addInv_Docref = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/`, data);
};

export const billing_expense_getRef_TypeSOById = (inv_hid) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/getSOId/${inv_hid}`);
};

export const billing_expense_getTs_hListId = (inv_hid) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/getTsId/${inv_hid}`);
};

export const billing_expense_delete_docrefAD = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/docref_ad/${id}`);
};

export const billing_expense_delete_docrefTS = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/docref_ts/${id}`);
};

export const billing_expense_delete_docrefSO = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/docref_so/${id}`);
};

export const billing_expense_getRef_TypeCNById = (inv_hid) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/getCNId/${inv_hid}`);
};

export const billing_expense_delete_docrefCN = (id) => {
  return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_DOCREF}` + `/docref_cn/${id}`);
};